import React from "react";
import { useRecipients } from "../../hooks/custom/useRecipients";
import RecipientsHeader from "../ui/RecipientsHeader";
import RecipientsTable from "../tables/RecipientsTable";
import AddRecipientModal from "../modals/AddRecipientModal";
import ImportCsvModal from "../modals/ImportCsvModal";

const Recipients: React.FC = () => {
  const {
    // Data
    recipients,
    recipientsLoading,
    recipientsError,
    totalCount,

    // Search and filters
    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,

    // Pagination
    currentPage,
    pageSize,

    // Selection
    selectedRecipients,

    // Modal states
    showAddModal,
    setShowAddModal,
    showImportModal,
    setShowImportModal,

    // Form states
    newRecipient,
    setNewRecipient,
    csvFile,
    setCsvFile,
    isAddingRecipient,
    isImportingCsv,

    // Handlers
    handleAddRecipient,
    handleCsvImport,
    handleToggleSelect,
    handleSelectAll,
    handlePageChange,
    handleRefresh,
  } = useRecipients();

  if (recipientsError) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <h3 className="text-red-800 font-medium">Error Loading Recipients</h3>
        <p className="text-red-600 mt-1">{recipientsError}</p>
      </div>
    );
  }

  return (
    <div>
      {/* Header */}
      <RecipientsHeader
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        onAddRecipient={() => setShowAddModal(true)}
        onImportCsv={() => setShowImportModal(true)}
        onRefresh={handleRefresh}
        recipientsCount={totalCount}
        isLoading={recipientsLoading}
      />

      {/* Table */}
      <RecipientsTable
        recipients={recipients}
        selectedRecipients={selectedRecipients}
        onToggleSelect={handleToggleSelect}
        onSelectAll={handleSelectAll}
        onEditRecipient={() => {}} // TODO: Implement edit functionality
        onDeleteRecipient={() => {}} // TODO: Implement delete functionality
        currentPage={currentPage}
        pageSize={pageSize}
        totalCount={totalCount}
        onPageChange={handlePageChange}
      />

      {/* Modals */}
      <AddRecipientModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        newRecipient={newRecipient}
        setNewRecipient={setNewRecipient}
        onAddRecipient={handleAddRecipient}
        isLoading={isAddingRecipient}
      />

      <ImportCsvModal
        isOpen={showImportModal}
        onClose={() => setShowImportModal(false)}
        csvFile={csvFile}
        setCsvFile={setCsvFile}
        onImportCsv={handleCsvImport}
        isLoading={isImportingCsv}
      />
    </div>
  );
};

export default Recipients;
